import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

export const useStyles = ({
  custom: {
    palette: { colorSupportSteel },
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    icon: {
      color: colorSupportSteel,
      fontSize: 14,
      marginLeft: unit,
      marginRight: unit / 2,
      position: 'relative',
      bottom: unit / 4,
    },
  });
